const actions = {
  SET_STATE: 'reservation/SET_STATE',
  SET_ERROR_STATE: 'reservation/SET_ERROR_STATE',
  GET_RESERVATION_SETUP: 'reservation/GET_RESERVATION_SETUP',
  GET_TIME_SLOT: 'reservation/GET_TIME_SLOT',
  ADD_RESERVATION: 'reservation/ADD_RESERVATION',
  SEND_OTP: 'reservation/SEND_OTP',
  RESEND_OTP: 'reservation/RESEND_OTP',
  GET_DEVICE_INFO: 'reservation/GET_DEVICE_INFO',
  VERIFY_OTP: 'reservation/VERIFY_OTP',
  UPDATE_CUSTOMER: 'reservation/UPDATE_CUSTOMER',
  HANDLE_USER_TOKEN: 'reservation/HANDLE_USER_TOKEN',
}

export default actions
